import { render } from "./container-send-message-group.vue?vue&type=template&id=03471e3a"
import script from "./container-send-message-group.vue?vue&type=script&lang=js"
export * from "./container-send-message-group.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__